<p>Import Students</p>
<hr>
<div class="row g-4">
  <div class="col-12 col-xl-12">
    <mat-card>
      <mat-card-content>
        <h5 class="mb-3">Student Excel Upload</h5>
        <div class="row g-3">
          <!-- Course Dropdown -->
          <div class="col-12 col-md-6">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>Course</mat-label>
              <mat-select [(ngModel)]="selectedCourseId" name="course">
                <mat-option *ngFor="let course of courseList" [value]="course.id">{{ course.name }}-{{course.crs_code}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Semester Dropdown -->
          <!-- <div class="col-12 col-md-6">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>Semester</mat-label>
              <mat-select [(ngModel)]="selectedSemesterId" name="semester">
                <mat-option *ngFor="let sem of semesterList" [value]="sem.id">{{ sem.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div> -->

          <!-- File Upload -->
          <div class="col-12 col-md-6">
           <!-- Simple file input without mat-form-field -->
<label>Upload Excel File</label>
<input type="file" (change)="onFileChange($event)" />

          </div>
          <div class="col-12"><a href="/assets/student_sample.xlsx">Download Sample Sheet</a></div>

          <!-- Submit -->
          <div class="col-12">
            <button mat-flat-button color="primary" (click)="uploadStudents()">Upload</button>
          </div>

          <div *ngIf="validRows.length || invalidRows.length" class="mt-3">
            <mat-card>
              <mat-card-content>
                <p><strong>Valid Rows:</strong> {{ validRows.length }}</p>
                <p><strong>Invalid Rows:</strong> {{ invalidRows.length }}</p>
          
                <div *ngIf="invalidRows.length">
                  <p class="text-danger">Some rows have issues:</p>
                  <table class="table table-sm table-bordered">
                    <thead>
                      <tr>
                        <th>Row #</th>
                        <th>Errors</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of invalidRows">
                        <td>{{ row.row }}</td>
                        <td>
                          <ul>
                            <li *ngFor="let err of row.errors">{{ err }}</li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
